export default __webpack_public_path__ + "998fd4fa25c9376c9fc7ac765e8c5b95.mp3";